"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
function Divider() {
    return React.createElement(StyledHr, null);
}
exports.Divider = Divider;
var StyledHr = styled_components_1.default.hr(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  margin: 0;\n  border: none;\n  border-top: 1px solid #dbdbdb;\n"], ["\n  margin: 0;\n  border: none;\n  border-top: 1px solid #dbdbdb;\n"])));
var templateObject_1;
//# sourceMappingURL=index.js.map